import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=0ffaef74&"
import script from "./notFound.vue?vue&type=script&lang=js&"
export * from "./notFound.vue?vue&type=script&lang=js&"
import style0 from "./notFound.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports